import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from '~/techstyle-shared/next-routes';
import { Button } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import BuilderLocalizedText from '../BuilderLocalizedText';

const CtaNodeWrapper = styled.div``;

const StyledButton = styled(Button)`
  grid-column-end: span 1;
  max-width: 200px;
`;

const BrandedLink = styled.a`
  ${({ theme }) => theme.navigation.styledLink}
  ${({ theme }) => theme.ctaNode.linkText}
`;

const DynamicFormattedMessage = FormattedMessage;

export default function CtaNode({
  defaultMessage,
  messageId,
  variantStyle = 'primary',
  targetUrl = '/',
  onClick,
  ...rest
}) {
  const router = useRouter();
  const isTextLink = variantStyle === 'text_link';

  const message = () =>
    messageId ? (
      <DynamicFormattedMessage defaultMessage={defaultMessage} id={messageId} />
    ) : (
      <BuilderLocalizedText text={defaultMessage} />
    );

  const handleClick = (e) => {
    // Call custom onClick handler if provided
    if (onClick) {
      onClick(e);
    }

    router.push(targetUrl);
  };

  return isTextLink ? (
    <CtaNodeWrapper {...rest}>
      <Link href={targetUrl} passHref>
        <BrandedLink onClick={onClick}>{message()}</BrandedLink>
      </Link>
    </CtaNodeWrapper>
  ) : (
    <StyledButton variant={variantStyle} onClick={handleClick} {...rest}>
      {message()}
    </StyledButton>
  );
}

CtaNode.propTypes = {
  defaultMessage: PropTypes.string,
  messageId: PropTypes.string,
  onClick: PropTypes.func,
  targetUrl: PropTypes.string,
  variantStyle: PropTypes.string,
};
